import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  () => ({
    container: {
      position: 'relative',
      overflow: 'hidden',
    },
  }),
  { name: 'ExperienceList' },
);

export default useStyles;
